import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCountry } from '@/context/CountryContext';

const COUNTRY_META = {
  uae: {
    title: 'ASTIIV BASGAT UAE — Luxury Lifestyle & Real Estate Intelligence',
    description: 'AI-powered luxury lifestyle bundles, premium properties, and investment tools in Dubai & the UAE. Design your dream lifestyle within your budget.',
    locale: 'en-AE',
    hreflang: 'en-ae',
  },
  india: {
    title: 'ASTIIV BASGAT India — Premium Real Estate & Lifestyle Intelligence',
    description: 'AI-powered lifestyle bundles, premium properties, and investment tools across Mumbai, Delhi, Bangalore & top Indian cities. Smart investments for your dream lifestyle.',
    locale: 'en-IN',
    hreflang: 'en-in',
  },
};

const SEOHead = () => {
  const { countryCode } = useCountry();
  const location = useLocation();
  const meta = COUNTRY_META[countryCode] || COUNTRY_META.uae;
  const baseUrl = window.location.origin;

  useEffect(() => {
    document.title = meta.title;

    const setMeta = (name, content, attr = 'name') => {
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', meta.description);
    setMeta('og:title', meta.title, 'property');
    setMeta('og:description', meta.description, 'property');
    setMeta('og:locale', meta.locale, 'property');
    setMeta('og:url', `${baseUrl}${location.pathname}`, 'property');
    setMeta('og:type', 'website', 'property');

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${baseUrl}${location.pathname}`);

    // Hreflang tags
    const codes = ['uae', 'india'];
    const prefixMap = { uae: 'uae', india: 'in' };
    codes.forEach(code => {
      const linkId = `hreflang-${code}`;
      let link = document.getElementById(linkId);
      if (!link) {
        link = document.createElement('link');
        link.id = linkId;
        link.setAttribute('rel', 'alternate');
        document.head.appendChild(link);
      }
      link.setAttribute('hreflang', COUNTRY_META[code]?.hreflang || 'en');
      // Construct alternate URL by replacing country prefix
      const path = location.pathname.replace(/^\/(uae|in|india)/, '');
      link.setAttribute('href', `${baseUrl}/${prefixMap[code]}${path || ''}`);
    });

    // x-default
    let xDefault = document.getElementById('hreflang-default');
    if (!xDefault) {
      xDefault = document.createElement('link');
      xDefault.id = 'hreflang-default';
      xDefault.setAttribute('rel', 'alternate');
      xDefault.setAttribute('hreflang', 'x-default');
      document.head.appendChild(xDefault);
    }
    xDefault.setAttribute('href', `${baseUrl}/uae`);
  }, [countryCode, location.pathname, meta, baseUrl]);

  return null;
};

export default SEOHead;
